import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PayService } from 'src/app/service/pay.service';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-bussness-account',
  templateUrl: './bussness-account.component.html',
  styleUrls: ['./bussness-account.component.css'],
  standalone: false
})
export class BussnessAccountComponent implements OnInit {
  dtOptions: any = {};
  dtTrigger: Subject<any> = new Subject();
  persons: any[];
  constructor(private userService: PayService, private router: Router) { }

  ngOnInit(): void {
    $('#utilisateur').DataTable().init;
    this.findallBussnessAccount();
  }

  findallBussnessAccount() {

    $('#utilisateur').DataTable().destroy();
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      responsive: true
    };
    this.userService.getBussnessAcounts().subscribe((data: any[]) => {
      this.dtTrigger.next();
      this.persons = data;
      console.log(data);

    })
  }

  getAccountInformation(id, firstaname, lastname) {

    this.router.navigateByUrl("utilisarteur/admin/compte/affaire/information/" + id)

  }

  getAccountInformationprimaire(id, firstaname, lastname) {

    this.router.navigateByUrl("utilisateur/admin/compte/primaire/information/" + id)
  }

}
